import { render, staticRenderFns } from "./PhoneValidationIframeModal.vue?vue&type=template&id=4df7eab0&scoped=true&"
import script from "./PhoneValidationIframeModal.vue?vue&type=script&lang=ts&"
export * from "./PhoneValidationIframeModal.vue?vue&type=script&lang=ts&"
import style0 from "./PhoneValidationIframeModal.vue?vue&type=style&index=0&id=4df7eab0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df7eab0",
  null
  
)

export default component.exports